module.exports = __webpack_public_path__ + "img/no_sleep_gif.5cb2df48.gif";